import React from 'react';
import { Outlet } from 'react-router-dom';
import { Box } from '@mui/material';
import { acme, acmeMarketingPageSx } from '../theme/acmeTheme';

/** Full-viewport auth shell — no nav, no footer. */
export default function AuthLayout() {
  return (
    <Box
      sx={{
        ...acmeMarketingPageSx,
        minHeight: '100vh',
        backgroundColor: acme.colors.background,
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      <Outlet />
    </Box>
  );
}
